export default __webpack_public_path__ + "static/media/moba_logo.16a6e1cb.png";